import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'monthNumber',
  standalone: false,
})
export class MonthNumberPipe implements PipeTransform {

  transform(value: number): string {
    if (value === 1) {
      return `${value} month`
    }

    return `${value} months`
  }

}
